@if (!selectedSentence) {
  <h1 mat-dialog-title>{{ title }}</h1>
}
<div class="expression-explorer" [class.hidden]="selectedSentence">
  <app-sentence-table
    [expression]="data.expression"
    [rowsClickable]="true"
    [pageSize]="10"
    (rowClicked)="setSelectedSentence($event)"
    [displayingDeltaPlusMinusSentences]="displayingDeltaPlusMinusSentences"
    [displayingChipotletSentences]="displayingChipotletSentences"
  >
  </app-sentence-table>
</div>
